import React from 'react';
import { OrderShefProfileFragment } from 'src/gqlReactTypings.generated.d';
import {
  FaFacebookSquare,
  FaGlobeAmericas,
  FaInstagram,
  FaLinkedin,
  FaTikTok,
  FaTwitter,
} from 'src/shared/design-system/FontAwesome';
import { minScreen } from 'src/shared/utils/StyledComponentUtils';
import styled from 'styled-components';
import url from 'url';
import { Colors, Font, ScreenWidth, Spacing } from 'web-common/src/shared/styles';

const SocialIconsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${Spacing.HALF};
`;

const StyledSocialLink = styled.a`
  border-radius: 25px;
  border: 1px solid ${Colors.GRAY_LITE_20};
  min-width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${Spacing.HALF};
  background: ${Colors.WHITE};
  color: ${Colors.GRAY_DARK_20};
  font-size: ${Font.Size.XL};

  ${minScreen(ScreenWidth.SMALL)} {
    border: unset;
    background: ${Colors.GRAY_LITE_20};
    color: ${Colors.BLACK};
  }
`;

const StyledTikTokIcon = styled(FaTikTok)`
  margin-top: 3px;
  font-size: 19px;
`;
const StyledWebsiteIcon = styled(FaGlobeAmericas)`
  margin-right: ${Spacing.THREE_QUARTERS};
`;
const WebsiteUrl = styled.span`
  font-size: ${Font.Size.S};
  font-weight: ${Font.Weight.NORMAL};
  margin-right: ${Spacing.HALF};
`;

interface IProps {
  shefProfile: OrderShefProfileFragment;
  className?: string;
}
export const ShefSocialIconsRow: React.FC<IProps> = ({ shefProfile, className }) => (
  <SocialIconsRow className={className}>
    {shefProfile.facebookHandle && (
      <StyledSocialLink href={`https://facebook.com/${shefProfile.facebookHandle}`} target='_blank'>
        <FaFacebookSquare />
      </StyledSocialLink>
    )}
    {shefProfile.instagramHandle && (
      <StyledSocialLink href={`https://instagram.com/${shefProfile.instagramHandle}`} target='_blank'>
        <FaInstagram />
      </StyledSocialLink>
    )}
    {shefProfile.linkedInHandle && (
      <StyledSocialLink href={`https://linkedin.com/in/${shefProfile.linkedInHandle}`} target='_blank'>
        <FaLinkedin />
      </StyledSocialLink>
    )}
    {shefProfile.tikTokHandle && (
      <StyledSocialLink href={`https://tiktok.com/@${shefProfile.tikTokHandle}`} target='_blank'>
        <StyledTikTokIcon />
      </StyledSocialLink>
    )}
    {shefProfile.twitterHandle && (
      <StyledSocialLink href={`https://twitter.com/${shefProfile.twitterHandle}`} target='_blank'>
        <FaTwitter />
      </StyledSocialLink>
    )}
    {shefProfile.websiteUrl && (
      <StyledSocialLink href={shefProfile.websiteUrl} target='_blank'>
        <StyledWebsiteIcon />
        <WebsiteUrl>{url.parse(shefProfile.websiteUrl).host}</WebsiteUrl>
      </StyledSocialLink>
    )}
  </SocialIconsRow>
);
